import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-parameters',
  templateUrl: './create-parameters.component.html',
  styleUrls: ['./create-parameters.component.css']
})
export class CreateParametersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
